import { IsString } from "@pdfking/tfunc"
import object_map from "rfuncs/functions/object_map"

export default (object, keys) =>
  object_map(
    n => n,
    (n, k) => {
      const target = IsString(k) ? k : n
      return {
        get: () => object[target],
        set: v => (object[target] = v),
      }
    },
    keys
  )
